import styled from "styled-components";
import TextDotDivider from "../components/TextDotDivider";
import {useEffect, useState} from "react";
import {fetchProfInfo, fetchProfImage, fetchStudentTypes, fetchStudent} from "../serverAPI";
import dompurify from "dompurify";

const FacultyTitle = styled.p`
  font-weight: bold;
  font-family: "Droid Serif W01 Regular", serif;
  font-size: 24px;
  line-height: 1.3em;
  color: rgb(0, 49, 84);
`;

const FacultyDoubleBorder = styled.div`
  width: 100%;
  height: 3px;
  border-top: 2px solid rgb(0, 49, 84);
  border-bottom: 2px solid rgb(0, 49, 84);
`;

const ProfContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  margin-left: 20px;
  gap: 30px;
  margin-bottom: 70px;
`;

const ProfLeft = styled.div`
  width: 254px;
`;

const ProfRight = styled.div`
  width: 100%;
`;

const ProfImage = styled.img`
  width: 254px;
  height: 339px;
`;

const ProfName = styled.p`
  font-weight: bold;
  font-family: "Droid Serif W01 Regular", serif;
  color: rgb(0, 49, 84);
  font-size: 18px;
  margin: 15px 0;
`;

const ProfDescription = styled.p`
  font-size: 16px;
  line-height: 2em;
`;

const ProfRightTextTitle = styled.p`
  font-weight: bold;
  font-family: "Droid Serif W01 Regular", serif;
  font-size: 18px;
  color: rgb(0, 49, 84);
`;

const ProfRightDivide = styled.div`
  width: 100%;
  height: 2px;
  background-color: rgb(0, 49, 84);
  margin-top: 3px;
  margin-bottom: 5px;
`;

const ProfEducation = styled.p`
  font-size: 16px;
  line-height: 2em;
  margin-bottom: 40px;
`;

const SanitizerInner = styled.div`
  font-size: 16px;
  line-height: 2em;
`;

const AppointmentsContainer = styled.div`
  display: flex;
  gap: 5px;
  line-height: 2em;
`;

const StudentContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 30px;
`;

const Student = styled.div`
  display: flex;
  gap: 8px;
  font-size: 15px;
  line-height: 2em;
  width: 48%;
`;

const StudentImage = styled.img`
  width: 172px;
  height: 218px;
`;

const SanitizerStudentInner = styled.div`
  font-size: 15px;
  line-height: 2em;
`;

export default function People() {
  const sanitizer = dompurify.sanitize;
  const [profImage, setProfImage] = useState("");
  const [info, setInfo] = useState("");
  const [education, setEducation] = useState("");
  const [appointments, setAppointments] = useState("");
  const [students, setStudents] = useState([]);
  const [studentTypes, setStudentTypes] = useState([]);

  useEffect(() => {
    // API 호출로 professor 데이터 가져오기
    async function fetchData() {
      const profData = await fetchProfInfo();  // fetchProfInfo 함수를 통해 API 호출
      const profImageURL = await fetchProfImage();
      const infoData = profData.find(item => item.name === "info");       // info 데이터 가져오기
      const educationData = profData.find(item => item.name === "education"); // education 데이터 가져오기
      const appointmentsData = profData.find(item => item.name === "appointments"); // appointments 데이터 가져오기
      const types = await fetchStudentTypes();
      const allStudents = await fetchStudent();

      if (allStudents) {
        setStudents(allStudents);
      }
      if (types) {
        setStudentTypes(types);
        console.log(types);
      }
      if (profImageURL) {
        setProfImage(profImageURL);  // 가져온 profImage 데이터
      }
      if (infoData) {
        setInfo(infoData.text);  // 가져온 info 데이터 설정
      }
      if (educationData) {
        setEducation(educationData.text); // 가져온 education 데이터 설정
      }
      if (appointmentsData) {
        setAppointments(appointmentsData.text); // 가져온 appointments 데이터 설정
      }
    }

    fetchData();  // 데이터 fetch 함수 실행
  }, []);

  const appointmentsSplit = appointments.split(/<\/div>/)
  .filter(item => item.trim() !== "")
  .map(item => item.replace(/<div[^>]*>/g, "").trim());  // <div> 제거하고 내부만 남김

  return (<div>
    <FacultyTitle>Faculty</FacultyTitle>
    <FacultyDoubleBorder></FacultyDoubleBorder>
    <ProfContainer>
      <ProfLeft>
        <ProfImage src={profImage} alt="professor"/>
        <ProfName>Sung-Hong Park, PhD</ProfName>
        <SanitizerInner
          dangerouslySetInnerHTML={{__html: sanitizer(info)}}/>
      </ProfLeft>
      <ProfRight>
        <ProfRightTextTitle>Education</ProfRightTextTitle>
        <ProfRightDivide/>
        <SanitizerInner style={{marginBottom: "40px"}}
          dangerouslySetInnerHTML={{__html: sanitizer(education)}}/>
        <ProfRightTextTitle>Academic and Non-academic Appointments</ProfRightTextTitle>
        <ProfRightDivide/>
        {appointmentsSplit.map((item, index) => (<AppointmentsContainer key={index}
          dangerouslySetInnerHTML={{__html: sanitizer(item)}}/>))}
      </ProfRight>
    </ProfContainer>
    <div style={{marginTop: "80px", marginBottom: "50px"}}>
      {studentTypes.map((type, index) => (<div key={type.id}>
        <TextDotDivider text={type.type}/>
        <StudentContainer>
          {students
          .filter((student) => student.type_id === type.id) // 유형별로 학생 필터링
          .map((student, index) => (<Student key={student.id}>
            <StudentImage src={student.path} alt="student"/>
            <SanitizerStudentInner
              dangerouslySetInnerHTML={{__html: sanitizer("&nbsp;" + student.info)}}/>
          </Student>))}
        </StudentContainer>
      </div>))}
    </div>
  </div>);
}
